import React, { useEffect, useState } from "react";
import { BASEAPIURL, token } from "../env";

const MessageBoard = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMessages = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      tokenData: token
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    try {
      const response = await fetch(`${BASEAPIURL}/GetMessage`, requestOptions);
      const data = await response.json();
      console.log("API Response:", data);

      if (data?.data && Array.isArray(data.data)) {
        // Sort by Timestamp descending
        const sortedMessages = data.data.sort((a, b) => new Date(b.Timestamp) - new Date(a.Timestamp));
        setMessages(sortedMessages);
      } else {
        console.warn("Unexpected response format:", data);
        setMessages([]);
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Failed to fetch messages.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const formatPhoto = (photo) => {
    if (!photo) return null;
    if (photo.startsWith("data:image/")) return photo;
    return `data:image/jpeg;base64,${photo}`;
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4 text-center">Thank You Messages</h2>

      {loading && <div className="alert alert-info">Loading messages...</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      {!loading && !error && messages.length === 0 && (
        <div className="alert alert-warning">No messages found.</div>
      )}

      <div className="row">
        {messages.map((msg) => (
          <div className="col-md-4 mb-4" key={msg.MessageID}>
            <div className="card h-100 shadow-sm">
              <img
                src={formatPhoto(msg.Photo) || "https://via.placeholder.com/250x200?text=No+Image"}
                alt={msg.Name}
                className="card-img-top"
                style={{ height: "200px", objectFit: "cover" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/250x200?text=No+Image";
                }}
              />
              <div className="card-body">
                <h5 className="card-title">{msg.Name || "Anonymous"}</h5>
                {msg.Designation && (
                  <p className="card-subtitle mb-2 text-muted">{msg.Designation}</p>
                )}
                <p className="card-text">{msg.Message}</p>
              </div>
              <div className="card-footer text-muted small">
                {msg.Timestamp
                  ? new Date(msg.Timestamp).toLocaleString()
                  : "No timestamp"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MessageBoard;
